import React from 'react';

import { useQuery, gql } from '@apollo/client';

import type { QueryHookOptions } from '@apollo/client';
import { JobHiringAttendance } from '../type';

type AttendancesData = { jobHiringAttendances: JobHiringAttendance[] };
type AttendancesVariables = { restaurantIds?: string[] };

const getAttendancesGql = gql(`
  query getJobHiringAttendances($restaurantIds: [ID!]) {
    jobHiringAttendances(restaurantIds: $restaurantIds) {
      id
      status
      startOperationTime
      startOperationPhoto
      startOperationLatitude
      startOperationLongitude
      endOperationTime
      endOperationPhoto
      endOperationLatitude
      endOperationLongitude
      breakDurationMinute
      jobHiring {
        id
        status
        job {
          id
          jobType
          jobStartAt
          jobEndAt
          breakDurationMinute
          jobDurationMinute
          otHour
        }
        student {
          id
          avatar
          nickName
          nameWithFallback
        }
        restaurant {
          id
          latitude
          longitude
        }
      }
    }
  }
`);

const useQueryAttendances = (options?: QueryHookOptions<AttendancesData, AttendancesVariables>) =>
  useQuery<AttendancesData, AttendancesVariables>(getAttendancesGql, options);

export default useQueryAttendances;
